import { render } from "./ParticipantInfo.vue?vue&type=template&id=66942b7b&scoped=true"
import script from "./ParticipantInfo.vue?vue&type=script&lang=js"
export * from "./ParticipantInfo.vue?vue&type=script&lang=js"

import "./ParticipantInfo.vue?vue&type=style&index=0&id=66942b7b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66942b7b"]])

export default __exports__